import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { MarketingService } from '../../../../../shared/_services/marketing.service';
import { HcaUserManagementService } from '../../../../../shared/_services/hca-user-management.service';

import { HttpService } from '../../../../../shared/_services/http.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';

import { ImageFile } from '../../../../../shared/_data-model/image-file';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../../../../shared/_services/util.service';
import { environment } from '../../../../../../environments/environment';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LoyaltyService } from '../../../../../shared/_services/loyalty.service';

@Component({
  selector: 'app-rewards-catalog-new-reward',
  templateUrl: './rewards-catalog-new-reward.component.html',
  styleUrls: ['./rewards-catalog-new-reward.component.scss']
})
export class RewardsCatalogNewRewardComponent implements OnInit {
  rewardCatalogId: number;
  tagInputText: string;
  successMsg: string;
  errorDetails: string;
  selectedHotels: any = [];
  isNewReward: boolean;
  rewardId: number;
  reward: any = FormGroup;
  myForm: any = FormGroup;
  items = [];
  searchTerm$ = new Subject<string>();
  hotelTags: any;
  catalogs: any;
  selectedCatalog: any;
  productTypes: any;
  currencies: any;
  providers: any;
  bsModalRef: BsModalRef;
  hotelBrands: any[] = [];
  selectedBrands: any[] = [];
  hotels: any[] = [];
  hotels_inactive: any[] = [];
  hotels_active: any[] = [];
  selectedBrand: any[] = [];
  imageFile: ImageFile = new ImageFile;
  imageFileEs: ImageFile = new ImageFile;
  hotelChainId: number = localStorage.getItem('loggedInUser') ? JSON.parse(
    localStorage.getItem('loggedInUser')).hotelChainId : null;
  @ViewChild('uploadFile') uploadFile: any;
  @ViewChild('uploadFileEs') uploadFileEs: any;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  personTypes: any;
  membershipLevel: any;
  selectedMembershipLevel: any;
  duplicatedCatalogs = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private loyaltyService: LoyaltyService,
    private marketingService: MarketingService,
    private hcaUserManagementService: HcaUserManagementService,
    private utilService: UtilService,
    private formBuilder: FormBuilder,
    private location: Location,
    private router: Router,
    private validationService: ValidationService,
  ) {
    this.hotelTags = (text: string): Observable<Response> => {
      const url = `/hotel/getHotelTags/product/${text}`;
      return this.http
        .get(url).debounceTime(300)
        .distinctUntilChanged()
        .map(data => {
          if (data.json().error === 0) {
            if (data.json().responseObj.length) {
              return data.json().responseObj;
            } else {
              this.tagInputText = '';
            }
          }
        });
    };

    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action === 'action1') {
            if (this.statusModal && this.statusModal.content && this.statusModal.content.srcObject &&
              this.statusModal.content.srcObject.type === 'hca-image') {

              if (this.statusModal.content.srcObject.langType === 'en') {
                this.imageFile.imageUrl = '';
              }
              if (this.statusModal.content.srcObject.langType === 'es') {
                this.imageFileEs.imageUrl = '';
              }
            } else if (this.statusModal.content.srcObject.type === 'reward-list-new') {
              let statusId: any;
              if (this.statusModal.content.srcObject.status === 'Activate') {
                statusId = 1;
              } else {
                statusId = 0;
              }
              this.marketingService.activateOrDeactivateRewardCatalog(this.statusModal.content.srcObject.id, statusId).subscribe(
                // tslint:disable-next-line:no-shadowed-variable
                res => {
                }, error => {
                  console.error(error);
                });
              // this.router.navigate(['./marketing/rewards-catalog']);
              this.location.back();
            }
            else if (this.statusModal.content.srcObject.type === 'reward-add') {
              // this.router.navigate(['/marketing/rewards-catalog']);
              this.location.back();
            }

          }
        }
      });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.rewardId = +params['id']; // (+) converts string 'id' to a number
      // this.rewardCatalogId = +params['catalog'];
      if (this.rewardId) {
        this.isNewReward = false;
        this.getRewardById(this.rewardId);
      } else {
        this.isNewReward = true;
      }
    });
    this.reward = this.fb.group({
      rewardId: [this.rewardId ? this.rewardId : ''],
      name: [''],
      productNameEN: ['', Validators.compose(
        [this.validationService.noWhitespaceValidator, Validators.maxLength(60), Validators.required])],
      productNameES: ['', Validators.compose(
        [this.validationService.noWhitespaceValidator, Validators.maxLength(60), Validators.required])],
      hotelChainId: [this.hotelChainId ? this.hotelChainId : ''],
      productDescriptionEN: [''],
      productDescriptionES: [''],
      percentOff: [''],
      tagIds: [''],
      statusId: [''],
      status: [''],
      inStay: [false],
      perNight: [false],
      perPerson: [false],
      serviceProviderId: [null, Validators.required],
      rewardHotels: this.fb.array([
        this.initRewardHotels(),
      ]),
      catalogValuesTo: this.fb.array([
        this.initCatalogValuesTo(),
      ]),
      productTypesTo: this.fb.group({
        productId: [''],
        productType: ['', Validators.required],
      }),
      programType: [null],
      rewardType: ['Automatic'],
      isFreeRedemption: [false],
      isFreeRedemptionOneTime: [{value: false, disabled: true}],
      isFreeRedemptionPerReservation: [{value: false, disabled: true}],
      isNewMembersOnly: [false],
      rewardPriority: ['Low', Validators.required],
      url: ['', Validators.compose(
        [this.validationService.noWhitespaceValidator])],
    });

    this.reward.get('isFreeRedemption').valueChanges.subscribe(active => {
      const oneTimeCtrl = this.reward.get('isFreeRedemptionOneTime');
      const perReservationCtrl = this.reward.get('isFreeRedemptionPerReservation');

      if (active) {
        oneTimeCtrl.enable({emitEvent: false});
        perReservationCtrl.enable({emitEvent: false});
      } else {
        oneTimeCtrl.disable({emitEvent: false});
        oneTimeCtrl.setValue(false, {emitEvent: false});
        perReservationCtrl.disable({emitEvent: false});
        perReservationCtrl.setValue(false, {emitEvent: false});
      }
    });

    this.reward.get('productTypesTo').get('productId').valueChanges
      .subscribe(val => {
        if (val === 1) {
          this.reward.get('percentOff').setValidators(
            [Validators.required, Validators.max(100), Validators.min(0), Validators.pattern(
              this.validationService.isNumber2Decimal_regexPattern)]);
          this.reward.get('percentOff').patchValue(null);
          this.reward.get('percentOff').updateValueAndValidity();
          this.reward.get('catalogValuesTo').controls.forEach((element, i) => {
            this.reward.get('catalogValuesTo').at(i).get('points').setValidators(null);
            this.reward.get('catalogValuesTo').at(i).get('points').patchValue(null);
            this.reward.get('catalogValuesTo').at(i).get('points').updateValueAndValidity();
          });
        } else {
          this.reward.get('percentOff').setValidators(null);
          this.reward.get('percentOff').patchValue(0);
          this.reward.get('percentOff').updateValueAndValidity();
          this.reward.get('catalogValuesTo').controls.forEach((element, i) => {
            this.reward.get('catalogValuesTo').at(i).get('points').setValidators(
              [Validators.max(99999999), Validators.required, Validators.pattern(
                this.validationService.isNumber_regexPattern)]);
            this.reward.get('catalogValuesTo').at(i).get('points').updateValueAndValidity();
          });
        }
      });
    this.getProgramTypes();
    this.getCatalogsList();
    this.getRewardProductTypes();
    this.getCurrencyTypes();
    this.getServiceProviders();
    this.getHotelBrandsByHotelChain();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  initProductTypesTo() {
    return this.fb.group({
      productId: [''],
      productType: [''],
    });
  }
  initRewardHotels() {
    return this.fb.group({
      hotelId: [],
      hotelName: [],
      brandId: [],
      website: [],
      totalRooms: [],
      hasPremiumServices: [],
    }, this.validationService.minLengthArray(1));
  }
  initTagIds() {
    return this.fb.group({
      tagId: [],
      name: [],
      type: [],
    });
  }
  initCatalogValuesTo() {
    return this.fb.group({
      points: [, Validators.compose(
        [Validators.max(99999999), Validators.required, Validators.pattern(
          this.validationService.isNumber_regexPattern)])],
      membershipLevel: this.fb.group({
        loyaltyId: ['', Validators.required],
        memberShipName: [],
        name: [],
        priorityId: [],
        createdDate: [],
        updatedBy: [],
        updatedDate: [],
        createdBy: [],
        loyaltyProgramTypeId: [],
        isEmployee: [],
        id: [],
      }),
      catalog: this.fb.group({
        catalogId: ['', Validators.required],
        catalogName: [],
        hotelChainId: [],
      }),
      descriptionEN: [''],
      descriptionES: [''],
    });
  }

  getProgramTypes() {
    this.loyaltyService.getProgramTypes().subscribe(res => {
      if (res.error === 0) {
        this.personTypes = res.responseObj;
        this.reward.get('programType').setValue(this.personTypes[0].loyaltyProgramTypeId);
      } else {
      }
    }, err => {
      console.error('Error getting person types: ', err.message);
    });
  }
  getCatalogsList() {
    this.marketingService.getCatalogs('true')
      .subscribe(
        res => {
          if (res.error === 0) {
            this.catalogs = res.responseObj;
            setTimeout(() => {
              this.selectedCatalog = this.reward.get('catalogValuesTo').value.map((item) =>  item.catalog );
              this.catalogs.forEach(c => {
                  if (c.catalogId === this.selectedCatalog[0].catalogId) {
                    this.membershipLevel = c.loyaltyIds;
                  }
              });
            }, 150);


          } else {
            console.error('get Catalogs :' + res.message);
          }
        },
        err => {
          console.error(err);
        });
  }

   getRewardProductTypes() {
    this.marketingService.getRewardProductTypes()
      .subscribe(
        res => {
          if (res.error === 0) {
            this.productTypes = res.responseObj;
          } else {
            console.error('get product types :' + res.message);
          }
        },
        err => {
          console.error(err);
        });
  }
  setCatalogValuesTo(catalog) {
    const catalogForm = this.reward.get('catalogValuesTo') as FormArray;
    catalogForm.push(this.fb.group({
      points: [catalog.points != null || catalog.points !== '' ? catalog.points : ''],
      membershipLevel: this.fb.group({
        loyaltyId: [catalog.membershipLevel.loyaltyId ? catalog.membershipLevel.loyaltyId : '', Validators.required],
        memberShipName: [catalog.membershipLevel.memberShipName ? catalog.membershipLevel.memberShipName : ''],
        name: [catalog.membershipLevel.name ? catalog.membershipLevel.name : ''],
        priorityId: [catalog.membershipLevel.priorityId ? catalog.membershipLevel.priorityId : ''],
        createdDate: [catalog.membershipLevel.createdDate ? catalog.membershipLevel.createdDate : ''],
        updatedBy: [catalog.membershipLevel.updatedBy ? catalog.membershipLevel.updatedBy : ''],
        updatedDate: [catalog.membershipLevel.updatedDate ? catalog.membershipLevel.updatedDate : ''],
        createdBy: [catalog.membershipLevel.createdBy ? catalog.membershipLevel.createdBy : ''],
        loyaltyProgramTypeId: [catalog.membershipLevel.loyaltyProgramTypeId ? catalog.membershipLevel.loyaltyProgramTypeId : ''],
        isEmployee: [catalog.membershipLevel.isEmployee ? catalog.membershipLevel.isEmployee : ''],
        id: [catalog.membershipLevel.id ? catalog.membershipLevel.id : ''],
      }),
      catalog: this.fb.group({
        catalogId: [catalog.catalog.catalogId ? catalog.catalog.catalogId : '', Validators.required],
        catalogName: [catalog.catalog.catalogName ? catalog.catalog.catalogName : 'catalog'],
        hotelChainId: [catalog.catalog.hotelChainId ? catalog.catalog.hotelChainId : '']
      }, this.validationService.minLengthArray(1)),
      descriptionEN: [catalog.descriptionEN ? catalog.descriptionEN : ''],
      descriptionES: [catalog.descriptionES ? catalog.descriptionES : ''],
    }));
  }

  setRewardHotels(hotel) {
    const rewardHotelsForm = this.reward.get('rewardHotels') as FormArray;
    rewardHotelsForm.push(this.fb.group({
      hotelId: [hotel.hotelId ? hotel.hotelId : ''],
      hotelName: [hotel.hotelName ? hotel.hotelName : ''],
      brandId: [hotel.brandId ? hotel.brandId : ''],
      website: [hotel.website ? hotel.website : ''],
      totalRooms: [hotel.totalRooms ? hotel.totalRooms : ''],
      hasPremiumServices: [hotel.hasPremiumServices ? hotel.hasPremiumServices : ''],
    }, this.validationService.minLengthArray(1)));
  }

  initForm(rewardObj) {
    const rewardHotels: FormArray = new FormArray([]);
    const catalogValuesTo: FormArray = new FormArray([]);
    this.reward = this.fb.group({
      rewardId: [this.rewardId],
      name: [rewardObj.name ? rewardObj.name : ''],
      productNameEN: [rewardObj.productNameEN ? rewardObj.productNameEN : '', Validators.compose(
        [this.validationService.noWhitespaceValidator, Validators.maxLength(60), Validators.required])],
      productNameES: [rewardObj.productNameES ? rewardObj.productNameES : '', Validators.compose(
        [this.validationService.noWhitespaceValidator, Validators.maxLength(60), Validators.required])],
      hotelChainId: [this.hotelChainId],
      serviceProviderId: [null, Validators.required],
      productDescriptionEN: [rewardObj.productDescriptionEN ? rewardObj.productDescriptionEN : ''],
      productDescriptionES: [rewardObj.productDescriptionES ? rewardObj.productDescriptionES : ''],
      percentOff: [rewardObj.percentOff ? rewardObj.percentOff : ''],
      tagIds: [rewardObj.tagIds ? rewardObj.tagIds : []],
      statusId: [rewardObj.statusId ? rewardObj.statusId : ''],
      status: [rewardObj.status ? rewardObj.status : ''],
      perNight: [rewardObj.perNight ? rewardObj.perNight : false],
      inStay: [rewardObj.inStay ? rewardObj.inStay : false],
      perPerson: [rewardObj.perPerson ? rewardObj.perPerson : false],
      productImageEN: [rewardObj.productImageEN ? rewardObj.productImageEN : null],
      productImageES: [rewardObj.productImageES ? rewardObj.productImageES : null],
      programType: [rewardObj.programType ? rewardObj.programType : 1],
      rewardHotels: rewardHotels,
      catalogValuesTo: catalogValuesTo,
      productTypesTo: this.fb.group({
        productId: [rewardObj.productTypesTo.productId ? rewardObj.productTypesTo.productId : ''],
        productType: [rewardObj.productTypesTo.productType ? rewardObj.productTypesTo.productType : ''],
      }),
      rewardType: [rewardObj.rewardType ? rewardObj.rewardType : 'Automatic'],
      rewardPriority: [rewardObj.rewardPriority ? rewardObj.rewardPriority : '', Validators.required],
      url: [rewardObj.url ? rewardObj.url : '', Validators.compose([this.validationService.noWhitespaceValidator])],
      isFreeRedemption: [rewardObj.isFreeRedemption ? rewardObj.isFreeRedemption : false],
      isFreeRedemptionOneTime: [rewardObj.isFreeRedemptionOneTime ? rewardObj.isFreeRedemptionOneTime : false],
      isFreeRedemptionPerReservation: [rewardObj.isFreeRedemptionPerReservation ? rewardObj.isFreeRedemptionPerReservation : false],
      isNewMembersOnly: [rewardObj.isNewMembersOnly ? rewardObj.isNewMembersOnly : false],
    });

    if (rewardObj) {
      rewardObj.catalogValuesTo.forEach(catalog => {
        this.setCatalogValuesTo(catalog);
      });
      rewardObj.rewardHotels.forEach(hotel => {
        this.setRewardHotels(hotel);
      });
    }

    this.reward.get('productTypesTo').get('productId').valueChanges
      .subscribe(val => {
        if (val === 1) {  //If Discount
          this.reward.get('percentOff').setValidators(
            [Validators.required, Validators.max(100), Validators.min(0), Validators.pattern(
              this.validationService.isNumber2Decimal_regexPattern)]);
          this.reward.get('percentOff').patchValue();
          this.reward.get('percentOff').updateValueAndValidity();
          this.reward.get('catalogValuesTo').controls.forEach((element, i) => {
            this.reward.get('catalogValuesTo').at(i).get('points').setValidators(null);
            this.reward.get('catalogValuesTo').at(i).get('points').patchValue();
            this.reward.get('catalogValuesTo').at(i).get('points').updateValueAndValidity();
          });
        } else {
          this.reward.get('percentOff').setValidators(null);
          this.reward.get('percentOff').patchValue(0);
          this.reward.get('percentOff').updateValueAndValidity();
          this.reward.get('catalogValuesTo').controls.forEach((element, i) => {
            this.reward.get('catalogValuesTo').at(i).get('points').setValidators(
              [Validators.max(99999999), Validators.required, Validators.pattern(
                this.validationService.isNumber_regexPattern)]);
            // this.reward.get('catalogValuesTo').at(i).get('points').patchValue();
            this.reward.get('catalogValuesTo').at(i).get('points').updateValueAndValidity();
          });

        }
      });
  }

  resetFileInput(element?) {
    this[element].nativeElement.value = '';
  }

  getRewardById(rewardId) {
    this.selectedHotels = [];
    this.selectedBrands = [];

    this.marketingService.getRewardById(rewardId)
      .subscribe(
        res => {
          if (res.error === 0) {
            this.initForm(res.responseObj);

            res.responseObj.rewardHotels.forEach(rewardHotel => {
              if (this.selectedHotels.indexOf(rewardHotel.hotelId) === -1) {
                this.selectedHotels.push(rewardHotel.hotelId);
              }
              if (this.selectedBrands.indexOf(rewardHotel.brandId) === -1) {
                this.selectedBrands.push(rewardHotel.brandId);
              }
              // image url for reward in English
              this.imageFile.name = res.responseObj.productImageEN;
              this.imageFile.imageUrl = res.responseObj.productImageEN && res.responseObj.productImageEN.indexOf(
                '/home/ubuntu') === -1 ? `${
                environment.BASE_IMAGE_API}/images/products/${res.responseObj.productImageEN}` : ``;

              // image url for reward in Spanish
              this.imageFileEs.name = res.responseObj.productImageES;
              this.imageFileEs.imageUrl = res.responseObj.productImageES && res.responseObj.productImageES.indexOf(
                '/home/ubuntu') === -1 ? `${
                environment.BASE_IMAGE_API}/images/products/${res.responseObj.productImageES}` : ``;
            });
          } else {
            console.error('Get Reward By Id :' + res.message);
          }
        },
        err => {
          console.error(err);
        });
  }
  getCurrencyTypes() {
    this.marketingService.getCurrencyTypes()
      .subscribe(
        res => {
          if (res.error === 0) {
            this.currencies = res.responseObj;
          } else {
            console.error('get currency :' + res.message);
          }
        },
        err => {
          console.error(err);
        });
  }

  getServiceProviders() {
  this.marketingService.getServiceProviders()
    .subscribe(
      res => {
        if (res.error === 0) {
          this.providers = res.responseObj;

          if (this.reward) {
            const currentProviderControl = this.reward.get('serviceProviderId');
            const currentProviderId = currentProviderControl ? currentProviderControl.value : null;

            if (!this.isNewReward) {
              const exists = this.providers.some(p => p.serviceProviderId === currentProviderId);
              if (!exists && this.providers.length > 0) {
                this.reward.get('serviceProviderId').setValue(this.providers[0].serviceProviderId);
              }
            } else {
              if (this.providers.length > 0) {
                this.reward.get('serviceProviderId').setValue(this.providers[0].serviceProviderId);
              }
            }
          }

        } else {
          console.error('get provider :' + res.message);
        }
      },
      err => {
        console.error(err);
      });
}


  getHotelBrandsByHotelChain() {
    this.hotelBrands = [];
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error === 0) {
          this.hotelBrands = res.responseObj;
          if (res.responseObj.length > 0) {
            this.selectedBrand = res.responseObj[0];
          }
        } else {
          console.error('Get Hotel Brands : ' + res.message);
        }
      }, err => {
        console.error(err);
      });
  }
  getHotelsByBrand() {
    this.hotels = [];
    this.hotels_active = [];
    if (this.selectedBrands) {
      this.hcaUserManagementService.getHotelsByBrand(this.selectedBrands).subscribe(
        res => {
          if (res.error === 0) {
            this.hotels = res.responseObj;
            // this.hotels_inactive = this.hotels.filter(hotel => hotel.status === "Inactive");
            this.hotels_active = this.hotels.filter(hotel => hotel.status === 'Active');
          } else {
            console.error('Get Hotels : ' + res.message);
          }
        }, err => {
          console.error(err);
        });
    }
  }

  removeCatalog(index) {
    const control = <FormArray>this.reward.controls['catalogValuesTo'];
    control.removeAt(index);
    this.checkDuplicatedCatalogs();
  }

  addCatalog() {
    const control = <FormArray>this.reward.controls['catalogValuesTo'];
    control.push(this.initCatalogValuesTo());
    setTimeout(() => {
      if (this.reward.get('productTypesTo').get('productId').value === 1) {
        this.reward.get('catalogValuesTo').controls.forEach((element, i) => {
          this.reward.get('catalogValuesTo').at(i).get('points').setValidators(null);
          this.reward.get('catalogValuesTo').at(i).get('points').patchValue();
          this.reward.get('catalogValuesTo').at(i).get('points').updateValueAndValidity();
        });
      } else {
        this.reward.get('catalogValuesTo').controls.forEach((element, i) => {
          this.reward.get('catalogValuesTo').at(i).get('points').setValidators(
            [Validators.max(99999999), Validators.required, Validators.pattern(
              this.validationService.isNumber_regexPattern)]);
          // this.reward.get('catalogValuesTo').at(i).get('points').patchValue();
          this.reward.get('catalogValuesTo').at(i).get('points').updateValueAndValidity();
        });
      }
    }, 150);
  }

  selectCatalog(catalog, i) {
    this.membershipLevel = catalog.loyaltyIds;
    this.reward.get('catalogValuesTo').at(i).get('catalog').patchValue(catalog);
    this.checkDuplicatedCatalogs();
  }

  selectLoyaltyLevel(level, i) {
    this.reward.get('catalogValuesTo').at(i).get('membershipLevel').patchValue(level);
    this.checkDuplicatedCatalogs();
  }

  checkDuplicatedCatalogs() {
    const keys = [];
    this.duplicatedCatalogs = false;
    for (const group of this.reward.get('catalogValuesTo').controls) {
      const key = group.get('catalog').value.catalogId + '-' + group.get('membershipLevel').value.loyaltyId;
      if (keys.indexOf(key) !== -1) {
        this.duplicatedCatalogs = true;
      }
      keys.push(key);
    }
  }

  saveBtnDisabled() {
    return !this.reward.valid || this.selectedHotels === 0  || this.duplicatedCatalogs;
  }

  selectCurrency(currency, i) {
    this.reward.get('catalogValuesTo').at(i).get('currency').patchValue(currency);
  }
  selectProductType(productType) {
    this.reward.get('productTypesTo').patchValue(productType);
  }

  selectHotels(event, hotel) {
    if (hotel) {
      const idx = this.selectedHotels.indexOf(hotel.hotelId);
      if (idx === -1) {
        this.selectedHotels.push(hotel.hotelId);
        if (this.isNewReward) {
          if (this.reward.get('rewardHotels').at(0).value && !this.reward.get(
            'rewardHotels').at(0).value.hotelId && !this.reward.get('rewardHotels').at(0).value.brandId) {
            this.reward.get('rewardHotels').removeAt(0);
          }
          <FormArray>this.reward.controls['rewardHotels'].push(this.fb.group({
            hotelId: [hotel.hotelId ? hotel.hotelId : ''],
            hotelName: [hotel.hotelName ? hotel.hotelName : ''],
            brandId: [hotel.brandId ? hotel.brandId : ''],
            website: [hotel.website ? hotel.website : ''],
            totalRooms: [hotel.totalRooms ? hotel.totalRooms : ''],
            hasPremiumServices: [hotel.hasPremiumServices ? hotel.hasPremiumServices : ''],
          }));
        } else {
          <FormArray>this.reward.controls['rewardHotels'].push(this.fb.group({
            hotelId: [hotel.hotelId ? hotel.hotelId : ''],
            hotelName: [hotel.hotelName ? hotel.hotelName : ''],
            brandId: [hotel.brandId ? hotel.brandId : ''],
            website: [hotel.website ? hotel.website : ''],
            totalRooms: [hotel.totalRooms ? hotel.totalRooms : ''],
            hasPremiumServices: [hotel.hasPremiumServices ? hotel.hasPremiumServices : ''],
          }));
        }

      } else {
        this.selectedHotels.splice(idx, 1);
        const index = this.reward.controls['rewardHotels'].controls.findIndex(
          x => x.value.hotelId === Number(hotel.hotelId));
        // let index = this.reward.controls['rewardHotels'].controls.findIndex(x => {
        //   x.value.hotelId == hotel.hotelId;
        // });
        this.reward.controls['rewardHotels'].removeAt(index);
      }
    }
  }

  addErrClassIfHasError(control: FormControl, errors: string[]) {
    const checks = errors.map(error => control.hasError(error));
    const checksSum = checks.reduce((a, b) => Number(a) + Number(b), 0);
    return checksSum && control.touched ? 'err' : '';
  }

  save(reward, isOther) {
    reward.value.hotelChainId = this.hotelChainId;
    const formData: any = new FormData();
    formData.append('reward', JSON.stringify(reward.value));

    if (this.imageFile.file) {
      // let fileName = this.imageFile.name ? `${this.utilService.getRandomInt(
      // 0, 1000000)}${this.imageFile.name}` : this.utilService.getRandomInt(0, 1000000);
      const fileName = this.imageFile.name ? this.utilService.getModifiedString(
        this.imageFile.name) : this.utilService.getRandomInt(0, 1000000);

      formData.append('productImageES', this.imageFile.file, fileName);
      formData.append('productImageEN', this.imageFile.file, fileName);
    } else {
      const file = new Blob([], { type: 'image/jpg' });
      formData.append('productImageES', file, null);
      formData.append('productImageEN', file, null);
    }

    this.marketingService.createRewardCatalog(formData)
      .subscribe(
        (res) => {
          if (res.error === 0) {
            if (isOther) {
              this.selectedHotels = [];
              this.selectedBrands = [];
              this.imageFile = new ImageFile;
              this.imageFileEs = new ImageFile;
              this.reward.reset();
              this.successMsg = 'Reward added successfully';
              setTimeout(() => {
                this.successMsg = '';
              }, 2000);
            } else {
              // this.router.navigate(['./marketing/rewards-catalog']);
              this.location.back();
            }
          } else {
          }
        },
        (err) => {
          console.error('Update Rewards : ' + err);
        });
  }

  selectBrands(event, brand) {
    const idx = this.selectedBrands.indexOf(Number(brand.brandId));
    const rewardHotelsLength = this.reward.controls['rewardHotels'].length;
    if (idx > -1) {
      this.selectedBrands.splice(idx, 1);
      for (let i = rewardHotelsLength - 1; i >= 0; i--) {
        // setTimeout(() => {
        if (<FormArray>this.reward.controls['rewardHotels'].at(i).controls['brandId'].value === brand.brandId) {
          this.selectedHotels.splice(i, 1);
          this.reward.get('rewardHotels').removeAt(i);
        }
        // }, 100);
      }
    } else {
      this.selectedBrands.push(brand.brandId);
    }
  }

  uploadImage(event: any, langType) {
    if (langType === 'en') {
      this.imageFile = this.utilService.uploadImage(event);
      if (this.imageFile.errorUpload || this.imageFile.fileSizeError) {
        // this.imageFile = new ImageFile;
        this.imageFile.imageUrl = '';
        this.imageFile.name = '';
        // this.imageFile.errorUpload = true;
      }
      this.resetFileInput('uploadFile');
    }
    if (langType === 'es') {
      this.imageFileEs = this.utilService.uploadImage(event);
      if (this.imageFileEs.errorUpload || this.imageFileEs.fileSizeError) {
        // this.imageFile = new ImageFile;
        this.imageFileEs.imageUrl = '';
        this.imageFileEs.name = '';
        // this.imageFile.errorUpload = true;
      }
      this.resetFileInput('uploadFileEs');
    }

  }

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'reward-add',
      title: 'Confirm',
      message: this.isNewReward ? 'Are you sure you want to cancel adding a new reward?' : '' +
        'Are you sure you want to cancel modifying a reward?',
      action1: 'Yes',
      action2: 'No',
      action: '',
    };
  }

  deleteImage(langType) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      langType: langType
    };
  }
  openModalActivateDeactivate(id, mode) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = '';
    let title = '';
    let action1 = '';
    let style = '';
    let status = '';
    if (mode === 'Active') {
      message = 'Are you sure you want to deactivate this reward?';
      title = 'Deactivate Reward';
      action1 = 'Deactivate';
      style = 'inactive';
      status = 'Inactive';
    } else if (mode === 'Inactive') {
      message = 'Are you sure you want to activate this reward?';
      title = 'Activate Reward';
      action1 = 'Activate';
      style = 'active';
      status = 'Activate';
    }
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'reward-list-new',
      title: title,
      message: message,
      status,
      id: [this.rewardId],
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/marketing/rewards-catalog-new-reward/rewards-catalog-new-reward.component.ts